(function () {
  const root = document.querySelector('.bb-moodboard');
  if (!root) return;

  const webhook = root.dataset.webhook;
  const selections = { bed: null, kast: null, nachtkastje: null, bedtextiel: null };
  const cache = new Map();
  let allBeds = [];
  let loadingTimer = null;

  const euro = new Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>\"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '\"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function normalizeTags(tags) {
    if (Array.isArray(tags)) return tags.map(String).map(t => t.trim()).filter(Boolean);
    return String(tags || '').split(',').map(t => t.trim()).filter(Boolean);
  }

  function minPrice(variants) {
    const values = (variants || []).map(v => Number(v.price)).filter(v => Number.isFinite(v) && v >= 0);
    return values.length ? Math.min.apply(null, values) : null;
  }

  function normalizeProduct(product) {
    const variants = product.variants || [];
    const price = minPrice(variants);
    return {
      id: String(product.id),
      title: product.title || '',
      handle: product.handle || '',
      url: '/products/' + product.handle,
      image: product.images && product.images[0] ? product.images[0].src : '',
      vendor: product.vendor || '',
      productType: product.product_type || '',
      tags: normalizeTags(product.tags),
      variants: variants.map(v => ({ title: v.title || '', options: Array.isArray(v.options) ? v.options : [] })),
      price: price,
      priceLabel: price === null ? '' : 'Vanaf ' + euro.format(price)
    };
  }

  async function loadCollection(handle) {
    if (cache.has(handle)) return cache.get(handle);
    const response = await fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250', { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Producten konden niet worden geladen');
    const data = await response.json();
    const products = (data.products || []).map(normalizeProduct);
    cache.set(handle, products);
    return products;
  }

  function bedTypes(product) {
    const tags = product.tags.map(t => t.toLowerCase());
    const types = [];
    const rules = [
      ['boxsprings', 'Boxspring'],
      ['ledikanten', 'Ledikant'],
      ['waterbedden', 'Waterbed'],
      ['hoog-laagbedden', 'Hoog-laagbed']
    ];
    rules.forEach(([tag, label]) => {
      if (tags.includes(tag)) types.push(label);
    });
    if (!types.length && product.productType) types.push(product.productType);
    return Array.from(new Set(types));
  }

  function adjustability(product) {
    const blob = [
      product.title,
      product.productType,
      product.tags.join(' '),
      ...product.variants.map(v => v.title + ' ' + v.options.join(' '))
    ].join(' ').toLowerCase();
    return {
      vast: blob.includes('vast'),
      verstelbaar: blob.includes('verstelbaar') || blob.includes('hoog-laag') || blob.includes('hoog laag')
    };
  }

  function isDuvetCover(product) {
    const blob = [product.title, product.productType, product.tags.join(' ')].join(' ').toLowerCase();
    return blob.includes('dekbedovertrek');
  }

  function isNightstand(product) {
    const blob = [product.title, product.productType, product.tags.join(' ')].join(' ').toLowerCase();
    return blob.includes('nachtkast');
  }

  function productCard(product, key) {
    const selected = selections[key] && selections[key].id === product.id;
    return '<button type="button" class="bbm-card' + (selected ? ' is-selected' : '') + '" data-id="' + escapeHtml(product.id) + '" aria-pressed="' + (selected ? 'true' : 'false') + '">' +
      '<div class="bbm-card-image">' + (product.image ? '<img loading="lazy" src="' + escapeHtml(product.image) + '" alt="">' : '<span>Geen afbeelding</span>') + '</div>' +
      '<div class="bbm-card-copy"><strong>' + escapeHtml(product.title) + '</strong>' + (product.priceLabel ? '<small>' + escapeHtml(product.priceLabel) + '</small>' : '') + '</div>' +
      '</button>';
  }

  function noneCard(key, label) {
    const selected = !selections[key];
    return '<button type="button" class="bbm-card bbm-none-card' + (selected ? ' is-selected' : '') + '" data-none="true" aria-pressed="' + (selected ? 'true' : 'false') + '">' +
      '<div class="bbm-card-image bbm-none-image"><span aria-hidden="true">×</span></div>' +
      '<div class="bbm-card-copy"><strong>' + escapeHtml(label) + '</strong><small>Deze stap overslaan</small></div>' +
      '</button>';
  }

  function bindPicker(element, products, key, optionalLabel) {
    element.querySelectorAll('.bbm-card').forEach(card => {
      card.addEventListener('click', function () {
        if (card.dataset.none === 'true') {
          selections[key] = null;
        } else {
          selections[key] = products.find(p => p.id === card.dataset.id) || null;
        }
        renderPicker(element, products, key, optionalLabel);
      });
    });
  }

  function renderPicker(element, products, key, optionalLabel) {
    const prefix = optionalLabel ? noneCard(key, optionalLabel) : '';
    if (!products.length && !optionalLabel) {
      element.innerHTML = '<p class="bbm-empty">Geen passende producten gevonden.</p>';
      return;
    }
    element.innerHTML = prefix + products.map(p => productCard(p, key)).join('');
    bindPicker(element, products, key, optionalLabel);
  }

  function fillSelect(select, values, firstLabel) {
    select.innerHTML = '<option value="">' + escapeHtml(firstLabel) + '</option>' + values.map(value => '<option value="' + escapeHtml(value) + '">' + escapeHtml(value) + '</option>').join('');
  }

  function setupBedFilters(products) {
    const brands = Array.from(new Set(products.map(p => p.vendor).filter(Boolean))).sort((a, b) => a.localeCompare(b, 'nl'));
    const types = Array.from(new Set(products.flatMap(bedTypes))).sort((a, b) => a.localeCompare(b, 'nl'));
    fillSelect(root.querySelector('#bbmBrandFilter'), brands, 'Alle merken');
    fillSelect(root.querySelector('#bbmTypeFilter'), types, 'Alle bedtypes');

    ['#bbmBrandFilter', '#bbmTypeFilter', '#bbmAdjustFilter'].forEach(selector => {
      root.querySelector(selector).addEventListener('change', renderFilteredBeds);
    });
    renderFilteredBeds();
  }

  function renderFilteredBeds() {
    const brand = root.querySelector('#bbmBrandFilter').value;
    const type = root.querySelector('#bbmTypeFilter').value;
    const adjust = root.querySelector('#bbmAdjustFilter').value;
    const products = allBeds.filter(product => {
      if (brand && product.vendor !== brand) return false;
      if (type && !bedTypes(product).includes(type)) return false;
      const flags = adjustability(product);
      if (adjust === 'vast' && !flags.vast) return false;
      if (adjust === 'verstelbaar' && !flags.verstelbaar) return false;
      return true;
    });
    root.querySelector('#bbmBedCount').textContent = products.length + (products.length === 1 ? ' bed' : ' bedden');
    renderPicker(root.querySelector('[data-picker="bed"]'), products, 'bed');
  }

  async function init() {
    const pickers = root.querySelectorAll('.bbm-products');
    pickers.forEach(picker => { picker.innerHTML = '<div class="bbm-inline-loading"><span class="bbm-mini-spinner"></span>Producten laden…</div>'; });

    try {
      const [beds, cabinets, nightstands, textiles] = await Promise.all([
        loadCollection('bedden'),
        loadCollection('kasten'),
        loadCollection('nachtkastjes'),
        loadCollection('bedtextiel')
      ]);
      allBeds = beds;
      setupBedFilters(allBeds);
      const cabinetProducts = cabinets.filter(product => !isNightstand(product));
      renderPicker(root.querySelector('[data-picker="kast"]'), cabinetProducts, 'kast', 'Geen kast selecteren');
      renderPicker(root.querySelector('[data-picker="nachtkastje"]'), nightstands, 'nachtkastje', 'Geen nachtkastje selecteren');
      renderPicker(root.querySelector('[data-picker="bedtextiel"]'), textiles.filter(isDuvetCover), 'bedtextiel');
    } catch (error) {
      pickers.forEach(picker => { picker.innerHTML = '<p class="bbm-empty">Producten konden niet worden geladen. Ververs de pagina en probeer opnieuw.</p>'; });
    }
  }

  function chosenProducts() {
    return [selections.bed, selections.kast, selections.nachtkastje, selections.bedtextiel].filter(Boolean);
  }

  function renderChosen() {
    const wrap = root.querySelector('#bbmChosen');
    wrap.innerHTML = chosenProducts().map(product => {
      return '<a href="' + escapeHtml(product.url) + '" target="_blank" rel="noopener noreferrer">' +
        (product.image ? '<img src="' + escapeHtml(product.image) + '" alt="">' : '') +
        '<div class="bbm-chosen-copy"><strong>' + escapeHtml(product.title) + '</strong>' +
        (product.priceLabel ? '<span>' + escapeHtml(product.priceLabel) + '</span>' : '') + '</div></a>';
    }).join('');
  }

  function startLoading() {
    const imageWrap = root.querySelector('#bbmImageWrap');
    imageWrap.innerHTML = '<div class="bbm-generating"><span class="bbm-spinner" aria-hidden="true"></span><strong>We ontwerpen jouw droomslaapkamer</strong><p id="bbmLoadingText">We bekijken jouw gekozen producten…</p><div class="bbm-loading-dots"><i></i><i></i><i></i></div></div>';
    const messages = [
      'We bekijken jouw gekozen producten…',
      'We combineren bed, meubels en bedtextiel…',
      'We brengen jouw stijl en persoonlijke wensen samen…',
      'We werken de kleuren, materialen en sfeer verder uit…',
      'Bijna klaar — we leggen de laatste details in jouw droomslaapkamer vast…'
    ];
    let index = 0;
    loadingTimer = window.setInterval(function () {
      index = (index + 1) % messages.length;
      const target = root.querySelector('#bbmLoadingText');
      if (target) target.textContent = messages[index];
    }, 6500);
  }

  function stopLoading() {
    if (loadingTimer) window.clearInterval(loadingTimer);
    loadingTimer = null;
  }

  root.querySelector('#bbMoodboardForm').addEventListener('submit', async function (event) {
    event.preventDefault();
    const message = root.querySelector('#bbmMessage');
    const button = root.querySelector('.bbm-submit');

    if (!selections.bed) {
      message.textContent = 'Kies eerst een bed.';
      root.querySelector('[data-picker="bed"]').scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (!selections.bedtextiel) {
      message.textContent = 'Kies eerst een dekbedovertrek.';
      root.querySelector('[data-picker="bedtextiel"]').scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    const formData = new FormData(event.currentTarget);
    const bed = selections.bed;
    const cabinet = selections.kast;
    const nightstand = selections.nachtkastje;
    const textile = selections.bedtextiel;

    const payload = new URLSearchParams({
      action: 'create',
      request_id: crypto.randomUUID ? crypto.randomUUID() : Date.now() + '-' + Math.random().toString(16).slice(2),
      name: String(formData.get('name') || ''),
      email: String(formData.get('email') || ''),
      style: String(formData.get('style') || ''),
      style_details: String(formData.get('style_details') || ''),
      marketing_consent: 'true',
      bed_product_id: bed.id,
      bed_title: bed.title,
      bed_url: bed.url,
      bed_image: bed.image,
      bed_price: bed.price === null ? '' : String(bed.price),
      kast_selected: cabinet ? 'true' : 'false',
      kast_product_id: cabinet ? cabinet.id : '',
      kast_title: cabinet ? cabinet.title : '',
      kast_url: cabinet ? cabinet.url : '',
      kast_image: cabinet ? cabinet.image : '',
      kast_image_ai: cabinet && cabinet.image ? cabinet.image : bed.image,
      kast_price: cabinet && cabinet.price !== null ? String(cabinet.price) : '',
      nachtkastje_selected: nightstand ? 'true' : 'false',
      nachtkastje_product_id: nightstand ? nightstand.id : '',
      nachtkastje_title: nightstand ? nightstand.title : '',
      nachtkastje_url: nightstand ? nightstand.url : '',
      nachtkastje_image: nightstand ? nightstand.image : '',
      nachtkastje_image_ai: nightstand && nightstand.image ? nightstand.image : bed.image,
      nachtkastje_price: nightstand && nightstand.price !== null ? String(nightstand.price) : '',
      bedtextiel_product_id: textile.id,
      bedtextiel_title: textile.title,
      bedtextiel_url: textile.url,
      bedtextiel_image: textile.image,
      bedtextiel_price: textile.price === null ? '' : String(textile.price),
      source: 'shopify-ai-moodboard-live'
    });

    button.disabled = true;
    button.dataset.originalText = button.textContent;
    button.textContent = 'Droomslaapkamer ontwerpen…';
    message.textContent = 'Dit duurt meestal ongeveer een halve minuut.';
    renderChosen();

    const result = root.querySelector('#bbmResult');
    result.hidden = false;
    startLoading();
    result.scrollIntoView({ behavior: 'smooth', block: 'start' });

    try {
      const response = await fetch(webhook, { method: 'POST', body: payload });
      let data = {};
      try { data = await response.json(); } catch (_) {}

      if (data.status === 'rejected' || data.error_type === 'invalid_style_request') {
        stopLoading();
        const rejectionMessage = data.message || 'Vul hier alleen normale stijl- en interieurwensen voor een slaapkamer in.';
        root.querySelector('#bbmImageWrap').innerHTML = '<div class="bbm-generating bbm-error"><strong>Deze extra wens kan niet worden gebruikt.</strong><p>' + escapeHtml(rejectionMessage) + '</p></div>';
        message.textContent = rejectionMessage;
        document.dispatchEvent(new CustomEvent('bbm:style-rejected', { detail: { message: rejectionMessage } }));
        return;
      }

      if (!response.ok) throw new Error('Aanvraag mislukt');
      stopLoading();
      if (data.generated_image_url) {
        root.querySelector('#bbmImageWrap').innerHTML = '<img src="' + data.generated_image_url + '" alt="Persoonlijk slaapkamerontwerp">';
        message.textContent = 'Jouw persoonlijke slaapkamerontwerp is klaar.';
      } else {
        root.querySelector('#bbmImageWrap').innerHTML = '<div class="bbm-generating"><strong>Je aanvraag is ontvangen.</strong><p>De afbeelding wordt nog verwerkt.</p></div>';
        message.textContent = 'Je aanvraag is ontvangen.';
      }
    } catch (error) {
      stopLoading();
      root.querySelector('#bbmImageWrap').innerHTML = '<div class="bbm-generating bbm-error"><strong>Ontwerpen is niet gelukt.</strong><p>Probeer het nog een keer.</p></div>';
      message.textContent = 'Er ging iets mis. Probeer het opnieuw.';
    } finally {
      button.disabled = false;
      button.textContent = button.dataset.originalText || 'Ontwerp mijn droomslaapkamer';
    }
  });

  init();
})();
